var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-date-selector"},[_c('span',{on:{"click":_vm.selectPrevious}},[_vm._v("<")]),_c('span',{on:{"click":_vm.selectCurrent}},[_vm._v("Ma")]),_c('span',{on:{"click":_vm.selectNext}},[_vm._v(">")])])
}
var staticRenderFns = []

export { render, staticRenderFns }